import { ca } from '@cian/analytics';

export interface IHostTrackingUser {
  userId: number;
  isAuthorized: boolean;
}

interface IHostEventParams {
  action: string;
  label?: string;
  category?: string;
  extra?: Record<string, unknown>;
}

type THostEvent = (user: IHostTrackingUser, runtimeExtra?: Record<string, unknown>) => void;

const HOST_EVENT_CATEGORY = 'landing_dailyrent_guide_publish';

export const createHostEvent = ({ category = HOST_EVENT_CATEGORY, extra, ...params }: IHostEventParams): THostEvent => {
  return (user: IHostTrackingUser, runtimeExtra?: Record<string, unknown>): void => {
    ca('eventSite', {
      name: 'oldevent',
      category,
      ...params,
      page: {
        pageType: 'DailyrentLandingGuidePublish',
        extra: {
          ...extra,
          ...runtimeExtra,
        },
        user: {
          userId: user.userId,
          is_authorized: user.isAuthorized,
        },
      },
    });
  };
};

/** Клик на тогл переключения с квартиры на дом */
export const caHostPageCategory = createHostEvent({
  action: 'click',
  label: 'page_category',
});

/** Пользователь кликнул на статью в лендинге */
export const caHostArticle = createHostEvent({
  action: 'click',
  label: 'article',
});

/** Клик на любую кнопку «разместить объявление» */
export const caHostButton = createHostEvent({
  action: 'click',
  label: 'button',
  extra: {
    buttonText: 'Разместить объявление',
  },
});

/** Пользователь кликнул на кнопку «как это работает» */
export const caHostHowItsWork = createHostEvent({
  action: 'click',
  label: 'how_its_work',
});

/** Пользователь кликнул на вопрос */
export const caHostQuestion = createHostEvent({
  action: 'click',
  label: 'question',
});

/** Пользователь кликнул на иконку соцсетей */
export const caHostSocial = createHostEvent({
  action: 'click',
  label: 'social',
});
